import { Col, Collapse, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import BuddhiMedUploadListItem from '../fileUpload/BuddhiMedUploadListItem';
import { UploadFile } from 'antd/lib/upload/interface';
import { setModalSwitch } from '../../../store/actions/newAdmissionAction';
import { NEW_UPLOAD_STATUS } from '../../constants/crmConstants';
import { centeredNotification, isNonIntegratedPayer } from '../../../utils/utility';
import { alreadyUploadedDocs } from '../../../modules/crm/inPatient/service/crmUtils';

const ClassifiedDocuments = ({ form, settlementDocuments }: any): any => {
  const { Panel } = Collapse;
  const { newAdmission: { uploadedFiles }, payerList: { payer },
    admissionDetails: { claimDetails: { nextAllowStatus = [], claimFlowData = [] } } }
    = useSelector((state: RootState): any => state);
  const { totalFileSizeInMB, maxFileCount, shortName, isRpaPayer, isOnMailPayer} = payer;
  const fileCountObject = JSON.parse(totalFileSizeInMB || '{}');
  const nextStatus = nextAllowStatus[0] || 'NEWADMISSION';
  const totalFileSizeInNumber = fileCountObject[nextStatus];
  const maxFileCountObject = JSON.parse(maxFileCount || '{}');
  const numberOfFilesLimit = maxFileCountObject[nextStatus];

  const [selectedFiles, setSelectedFiles] = useState([] as any);
  const dispatch = useDispatch();
  const payerDocuments = alreadyUploadedDocs(claimFlowData).filter((file: any): any => {
    return file?.isPayerAttachment;
  });

  const providerDocuments = alreadyUploadedDocs(claimFlowData).filter((file: any): any => {
    return !file?.isPayerAttachment;
  });

  const onFileSelectToggle = (uid: any = ''): any => {
    let files = selectedFiles;
    if (uid !== '') {
      files = files?.includes(uid) ? files.filter((f: any): any => f !== uid) : [...files, uid];
    }
    const allSettlementDocs = [...payerDocuments, ...providerDocuments];
    const finalFiles = allSettlementDocs?.filter((file: any): any => {
      return files.includes(file.uid);
    });
    if (shortName === 'SHAI' && (isNonIntegratedPayer(isRpaPayer , isOnMailPayer))) {
      const { fileUploadRemark, claimedAmount, dateOfAdmission, dateOfDischarge, inPatientNumber, isDischargeCase: isDischargeCaseForm,
        settlementType, recieptNo, branch, documentType, noOfFiles, selectedOldFile, switchClick } = form?.getFieldsValue(['fileUploadRemark',
          'claimedAmount', 'dateOfAdmission', 'dateOfDischarge', 'inPatientNumber', 'isDischargeCase', 'recieptNo',
          'settlementType', 'branch', 'documentType', 'noOfFiles', 'selectedOldFile', 'switchClick']) || {};
      form?.resetFields();
      form?.setFieldsValue({
        fileUploadRemark, claimedAmount, dateOfAdmission, dateOfDischarge, inPatientNumber,
        isDischargeCase: isDischargeCaseForm, settlementType, recieptNo, branch, documentType, noOfFiles, selectedOldFile, switchClick,
      });
    }

    const newFileUploads = uploadedFiles?.filter((file: any): any => file?.claimStatus === NEW_UPLOAD_STATUS);
    // to enable/disable the submit button
    if (files?.length > 0) {
      dispatch(setModalSwitch(false));
    } else if (files?.length === 0 && newFileUploads?.length === 0) {
      dispatch(setModalSwitch(true));
    }

    // to validate the size of files uploaded
    let totalUploadedFilesSize = 0;
    const MB2Bytes = 1024 * 1024;
    // // to get the total newly uploaded files' size
    const totalNewlyUploadedFiles = [...newFileUploads, ...finalFiles];
    totalNewlyUploadedFiles.map((file: any): any => {
      totalUploadedFilesSize += file?.size;
    });
    if (numberOfFilesLimit) { // validation to check the maximum number of files uploaded
      if (totalNewlyUploadedFiles?.length > numberOfFilesLimit) {
        centeredNotification(`Maximum file allowed is ${numberOfFilesLimit}`);
      }
    }
    if (totalFileSizeInNumber) {
      if (totalUploadedFilesSize > (totalFileSizeInNumber * MB2Bytes)) {
        centeredNotification(`Maximum total file size limit is ${totalFileSizeInNumber} MB`);
      }
    }

    // set the selected files in the state;
    setSelectedFiles(files);
    form.setFieldsValue({ selectedOldFile: finalFiles });
  };

  useEffect((): any => {
    onFileSelectToggle();
  }, [uploadedFiles]);

  return (
    <React.Fragment>
      <div className="old-documents-header my-sm">{`Available Documents (${payerDocuments?.length + providerDocuments?.length})`}</div>
      <Collapse className="my-sm" expandIconPosition="right" defaultActiveKey={['1']}>
        <Panel header={`1. Payer Documents (${payerDocuments?.length})`} key="payer">
          {
            payerDocuments?.length > 0 ?
              <Row gutter={GUTTOR_SPACE} className="mb-sm">
                <Col md={6}><strong>Documents</strong></Col>
                <Col md={6}><strong>Uploaded on</strong></Col>
                <Col md={4}><strong>Status</strong></Col>
                <Col md={5}><strong>Document type</strong></Col>
                <Col md={3}><strong>Select to submit</strong></Col>
              </Row>
              : null
          }
          {
            payerDocuments?.length > 0 ?
              <div>
                {payerDocuments?.map((file: UploadFile | any, index: number): ReactElement | null =>
                  <BuddhiMedUploadListItem file={file} key={file.uid} index={index}
                    fileListLength={payerDocuments?.length} selectionAllowed={true} onSelectToggle={onFileSelectToggle} />)}
              </div> : null
          }
        </Panel>
      </Collapse>
      <Collapse className="my-sm" expandIconPosition="right" defaultActiveKey={['1']}>
        <Panel header={`2. Provider Documents (${providerDocuments?.length})`} key="provider">
          {
            providerDocuments?.length > 0 ?
              <Row gutter={GUTTOR_SPACE} className="mb-sm">
                <Col md={6}><strong>Documents</strong></Col>
                <Col md={6}><strong>Uploaded on</strong></Col>
                <Col md={4}><strong>Status</strong></Col>
                <Col md={5}><strong>Document type</strong></Col>
                <Col md={3}><strong>Select to submit</strong></Col>
              </Row>
              : null
          }
          {
            providerDocuments?.length > 0 ?
              <div>
                {providerDocuments?.map((file: UploadFile | any, index: number): ReactElement | null =>
                  <BuddhiMedUploadListItem file={file} key={file.uid} index={index}
                    fileListLength={providerDocuments?.length} selectionAllowed={true} onSelectToggle={onFileSelectToggle} />)}
              </div> : null
          }
        </Panel>
      </Collapse>
    </React.Fragment>
  );
};
export default ClassifiedDocuments;
